// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"213":"9dc3f5ae","239":"9d435319","455":"79fa4d27"}[chunkId] + ".chunk.js";
};